export default "__VITE_ASSET__DqL9Ux2c__"